module.exports = __webpack_public_path__ + "img/person.b67d0a9d.svg";